import type { ApiClient } from './apiClient.tsx';
import { useAuth } from './authStore.tsx';

/**
 * AuthProvider가 만든 단일 ApiClient를 그대로 돌려준다(결정46).
 *
 * 종전에는 여기서 매번 새 ApiClient를 만들며 apiKey를 Bearer로 실었다. 사람은
 * 이제 세션 쿠키로 인가되므로(credentials:'include') 클라이언트가 키를 들고
 * 있을 필요가 없다 — 클라이언트를 authStore와 분리해 둘 이유가 사라졌다.
 * 같은 인스턴스를 쓰면 라이브 e2e(bearerTokenForTests)가 로그인 화면 없이도
 * 모든 화면에 동일한 Bearer 키를 실을 수 있다.
 */
export function useApiClient(): ApiClient {
  return useAuth().client;
}
